export const timeSince = (date: Date) => {
  if (typeof date !== 'object') {
    date = new Date(date);
  }

  var seconds = Math.floor((+new Date() - +date) / 1000);
  var intervalType;

  var interval = Math.floor(seconds / 31536000);
  if (interval >= 1) {
    intervalType = 'year';
  } else {
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      intervalType = 'month';
    } else {
      interval = Math.floor(seconds / 86400);
      if (interval >= 1) {
        intervalType = 'day';
      } else {
        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
          intervalType = 'hour';
        } else {
          interval = Math.floor(seconds / 60);
          if (interval >= 1) {
            intervalType = 'min';
          } else {
            interval = seconds;
            intervalType = 'sec';
          }
        }
      }
    }
  }

  if (interval > 1 || interval === 0) {
    intervalType += 's';
  }

  return interval + ' ' + intervalType;
};

export const getAbbreviatedDayOfTheWeek = (dateInMs: number) => {
  const d = new Date(dateInMs);
  switch (d.getDay()) {
    case 0:
      return 'Sun';
    case 1:
      return 'Mon';
    case 2:
      return 'Tue';
    case 3:
      return 'Wed';
    case 4:
      return 'Thu';
    case 5:
      return 'Fri';
    case 6:
      return 'Sat';
  }
  return 'Sun';
};

export const utcToLocalDate = (ms: number) => {
  const date = new Date(ms);
  return date.toLocaleDateString();
};

export const utcToLocalDateShort = (ms: number) => {
  const options: any = {
    month: 'short',
    day: 'numeric',
  };
  const date = new Date(ms);
  return date.toLocaleDateString('en-us', options);
};

export const utcToLocalDateLong = (ms: number) => {
  const options: any = {
    weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  const date = new Date(ms);
  return date.toLocaleDateString('en-us', options);
};

export const utcToLocalDateTime = (ms: number) => {
  const date = new Date(ms);
  return date.toLocaleString();
};

export const utcToLocalDateTimeShort = (ms: number) => {
  const options: any = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };
  const date = new Date(ms);
  return date.toLocaleString(undefined, options);
};
